import { render, staticRenderFns } from "./danke.vue?vue&type=template&id=20690e54&"
import script from "./danke.vue?vue&type=script&lang=js&"
export * from "./danke.vue?vue&type=script&lang=js&"
import style0 from "./danke.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports